import { LoadableAfterPaint } from '@confluence/loadable';

export const ViewPageDistinctionBanner = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewPageDistinctionBanner" */ '../src/view-page-distinction-banner/ViewPageDistinctionBanner.tsx'
			)
		).ViewPageDistinctionBanner,
});

export { useViewPageDistinctionBannerStore } from '../src/view-page-distinction-banner/ViewPageDistinctionBannerStore.ts';
export { BANNER_HEIGHT as VIEW_PAGE_DISTINCTION_BANNER_HEIGHT } from '../src/view-page-distinction-banner/BannerSize.ts';
